import { Button } from 'components/Button/Button';
import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SERVICE_INSPECTION_FORM_ID } from '../constants';
import { useServiceInspectionStore } from '../useStore';
import { ServiceInspection as messages } from '../messages';

export const ServiceInspectionFooter: VFC = () => {
  const { isSending } = useServiceInspectionStore();

  return (
    <Button key="submit" block form={SERVICE_INSPECTION_FORM_ID} htmlType="submit" loading={isSending} type="primary">
      <FormattedMessage {...messages.confirm} />
    </Button>
  );
};
